module.exports = __webpack_public_path__ + "static/img/sheild-2.2ec9938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sheild-2.png
// module id = UChH
// module chunks = 0